import React, { useRef, useLayoutEffect, useState } from "react";
import { ajustarPosicionTooltipMedido } from "../../../resources/agendaTooltipContent";

function AgendaTooltip(props) {
    const tooltipRef = useRef(null);
    const [pos, setPos] = useState({ top: props.top, left: props.left });

    useLayoutEffect(() => {
        setPos({ top: props.top, left: props.left });
    }, [props.top, props.left, props.display]);

    useLayoutEffect(() => {
        if (props.display !== 'block' || !tooltipRef.current || !props.anchorRect) {
            return;
        }

        const ajustada = ajustarPosicionTooltipMedido(
            props.anchorRect,
            tooltipRef.current,
            props.left
        );

        if (ajustada) {
            setPos(ajustada);
        }
    }, [props.display, props.contenido, props.anchorRect, props.left]);

    return (
        <div
            ref={tooltipRef}
            className="agenda-tooltip"
            dangerouslySetInnerHTML={{ __html: props.contenido }}
            style={{ top: pos.top, left: pos.left, display: props.display }}
        />
    );
}

export default AgendaTooltip;
